import * as React from 'react';
import TopbarWithNavigation from './topbar_with_navigation/topbar-with-navigation';
import SidebarMobile from './topbar_with_navigation/sidebar_mobile/sidebar_mobile';
import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router-dom';

export interface LayoutProps{
    isAuthenticated: boolean;
    isLoading: boolean;
}

const mapStateToProps = (state) => {
    const stateProps = {
        isAuthenticated: state.app.getIsAuthenticated(),
        isLoading: state.app.getIsLoading()
    };
    return stateProps;
};

class Layout extends React.PureComponent<LayoutProps & RouteComponentProps<any>> {


    public componentWillReceiveProps(props) {
        if(!props.isLoading && !this.props.isAuthenticated){
            this.props.history.push('/ingreso');
        }
    }

    public render() {
        return this.props.isAuthenticated ? <div>
            <TopbarWithNavigation/>
            <SidebarMobile/>
        </div> : null;
    }
}

export default withRouter(connect(mapStateToProps)(Layout));


// WEBPACK FOOTER //
// ./src/components/common/layout/layout.tsx